export default "__VITE_ASSET__CQj1s7yu__"